export class CreditsService {
  skippable = true;
  bSkip = true;

  titleText = "Credits"
  bgm = { name:'MenuScene', pan:0, pitch:100, volume:90 };
  blocks = [];

  #filePath = 'data/Credits.json';

  constructor() {
    this.#loadFileData();
  }

  start() {
    Yosemite.Credits.start();
  }

  #loadFileData() {
    if(this.blocks.length) return;

    const request = new XMLHttpRequest();
    request.open("GET", this.#filePath);
    request.overrideMimeType('application/json');
    request.onload = () => {
      if (request.status === 200) {
        this.blocks = JSON.parse(request.responseText);
      }
    };

    request.send();
  }
}

/*: Json instructions
* time    = amount of time text within tag is displayed before the next tag.
*           this can be -1 for auto
* scroll  = how fast the text scrolls. negative for up, positive for down
* fadeIn  = how fast the tag text fades in (make this 255 to instant appear)
* fadeOut = how fast the tag text fades out (255 to instant disappear)
* ypos    = the starting y position of the block of text on screen. This can
*           be a pixel value or you can use offtop or offbot to have the text
*           begind offscreen (so you can scroll it on)
* align   = left,center or right
* image   = image name in /img/titles1/ folder to use as background. Leave
*           this out to use the previous image.
*/
